/**
 * Hoàng Phúc Pack - B2B Quote Form & Conversion Tracking
 * Handles quote modal trigger, auto-fill product context, and GA4 events.
 */
(function ($) {
  'use strict';

  // Helper to determine click context
  function getElementLocation($el) {
    var loc = $el.attr('data-location') || $el.closest('[data-location]').attr('data-location');
    if (loc) return loc;
    if ($el.closest('.header, header, #header').length) return 'header';
    if ($el.closest('.sidebarCall, .mobile-bar, .bottom-bar').length) return 'mobile_bar';
    if ($el.closest('.footer, footer, #footer').length) return 'footer';
    if ($el.closest('.sidebar, aside').length) return 'sidebar';
    if ($el.closest('.product-detail, .product-main').length) return 'product_detail';
    return 'body';
  }

  // 1. Trigger Quote Modal via data-quote-open
  $(document).on('click', '[data-quote-open]', function (e) {
    var href = $(this).attr('href');
    if (href === '#' || !href) {
      e.preventDefault();
    }
    var $btn = $(this);
    var product = $btn.attr('data-product-title') || $btn.attr('data-product') || $btn.data('product-title') || $btn.data('product') || '';
    var location = getElementLocation($btn);

    try {
      sessionStorage.setItem('hp_quote_location', location);
      sessionStorage.setItem('hp_quote_product', product);
    } catch (err) {}

    var $modal = $('#contactModal');
    if ($modal.length) {
      // Always set the product input (resets previous value when empty)
      $modal.find('input[name="contact[Sản phẩm]"]').val(product);
      $modal.find('input[name="contact[Vị trí form]"]').val(location);
      $modal.modal('show');
    }

    // Push GA4 event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quote_open',
      form_location: location,
      product_name: product
    });
  });

  // 2. Track Call Clicks
  $(document).on('click', 'a[href^="tel:"]', function () {
    var phone = ($(this).attr('href') || '').replace('tel:', '').trim();
    var location = getElementLocation($(this));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click_call',
      phone_number: phone,
      click_location: location
    });
  });

  // 3. Track Zalo Clicks
  $(document).on('click', 'a[href*="zalo.me"]', function () {
    var location = getElementLocation($(this));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click_zalo',
      click_location: location
    });
  });

  // 4. Form Submit Guard (Placeholder Email, Context Persistence & Lead Worker Sync)
  $(document).on('submit', '.hp-quote-form, form[action*="/contact"]', function () {
    var $form = $(this);
    var loc = $form.find('input[name="contact[Vị trí form]"]').val() || getElementLocation($form);
    var prod = $form.find('input[name="contact[Sản phẩm]"]').val() || '';
    var name = $form.find('input[name="contact[name]"]').val() || '';
    var phone = $form.find('input[name="contact[phone]"]').val() || '';
    var qty = $form.find('[name="contact[Số lượng]"]').val() || '';
    var body = $form.find('textarea[name="contact[body]"]').val() || '';
    var email = $form.find('input[name="contact[email]"]').val() || '';

    try {
      sessionStorage.setItem('hp_quote_location', loc);
      sessionStorage.setItem('hp_quote_product', prod);
    } catch (err) {}

    var $email = $form.find('input[name="contact[email]"]');
    if ($email.length && !$email.val().trim()) {
      var fallbackEmail = window.HP_NO_EMAIL_PLACEHOLDER || 'khach-khong-de-email@hoangphucpack.com';
      $email.val(fallbackEmail);
      if (!email) email = fallbackEmail;
    }

    // Direct background ingestion to Cloudflare Lead Worker (Async, non-blocking)
    if (phone && window.fetch) {
      try {
        var workerUrl = 'https://hoangphucpack-lead-worker.hoangphucpack.workers.dev';
        var fullNote = body;
        if (qty) {
          fullNote = 'Số lượng: ' + qty + (body ? ' | ' + body : '');
        }
        var leadPayload = {
          ho_ten: name,
          so_dien_thoai: phone,
          email: email,
          san_pham: prod,
          noi_dung: fullNote,
          trang: window.location.href,
          vi_tri_form: loc,
          ma: 'HP-' + Date.now().toString(36).toUpperCase()
        };
        fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(leadPayload),
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      } catch (e) {}
    }
  });

  // 5. Success Event on Page Reload (?contact_posted=true)
  $(function () {
    if (/[?&]contact_posted=true/.test(location.search)) {
      var savedLoc = 'unknown';
      var savedProd = '';
      try {
        savedLoc = sessionStorage.getItem('hp_quote_location') || 'unknown';
        savedProd = sessionStorage.getItem('hp_quote_product') || '';
        sessionStorage.removeItem('hp_quote_location');
        sessionStorage.removeItem('hp_quote_product');
      } catch (err) {}

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'generate_lead',
        form_location: savedLoc,
        product_name: savedProd,
        lead_type: 'b2b_quote',
        form_page: location.pathname
      });

      // Show confirm modal if present
      if ($('#contactConfirmModal').length) {
        $('#contactConfirmModal').modal('show');
      }

      // Drop flag from URL so page refresh doesn't trigger another lead event
      if (window.history && window.history.replaceState) {
        var clean = location.pathname + location.search.replace(/[?&]contact_posted=true(&|$)/, '$1').replace(/\?$/, '') + location.hash;
        window.history.replaceState(null, '', clean);
      }
    }
  });

})(jQuery);
